
$(function() {
  $('.ques-heading').click(function(j) {

    var dropDown = $(this).closest('.questions__item_row').find('.ques-desc');
    $(this).closest('.question-body').find('.ques-desc').not(dropDown).slideUp();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $('.ques-heading.active').removeClass('active');
      $(this).addClass('active');
    }

    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });

});


$(function() {
 $('body.product-duo input[name="Bundle & Save"][value="2 Pack"]').prop("checked", true);
 $('body.product-duo input[name="Bundle & Save"][value="2 Set"]').prop("checked", true);  
 $('body.product-duo input[name="Bundle & Save"][value="2 Jar"]').prop("checked", true);   
 $('body.product-duo input[name="Buy 1 Get 1 FREE"][value="2 Pack"]').prop("checked", true);  
 $('body.product-duo input[name="Buy 1 Free 1"][value="2 Pack"]').prop("checked", true);      
     setTimeout(function() { 
       $('.custom-no-js').removeClass('custom-no-js');
    }, 3500);
 var check_var_price =  $('.qty_swatch input:checked+label').find('.var_price').text();
 var check_comvar_price =  $('.qty_swatch input:checked+label').find('.var_com_price').text();  
  $('.desk_stcy_price, .stcy_pro_price').text(check_var_price);
  $('.stcy_compro_price').text(check_comvar_price);
  console.log('readuy')
  $('.qty_swatch .element').click(function() {
    console.log('clickk')
   var var_price = $(this).find('.var_price').text();
   var comvar_price = $(this).find('.var_price').text(); 
    $('.desk_stcy_price, .stcy_pro_price').text(var_price);
    $('.stcy_compro_price').text(comvar_price);
  });
});

$(document).ready(function(){
  
$('.tab_nav li:first-child').addClass('active');
$('.tabcontent').hide();
$('.tabcontent:first').show();

// Click function
$('.tab_nav li').click(function(){
  $('.tab_nav li').removeClass('active');
  $(this).addClass('active');
  $('.tabcontent').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});  
  

$('a.value-props-btn').click(function(e){
  e.preventDefault();          
  $('.value-props-modal').css('display','block');
  $('body').css('overflow-y','hidden'); //Prevent double scrollbar.
});
$('.close-modal,.modal-sandbox').click(function(e){
  e.preventDefault();          
  $('.value-props-modal').css('display','none');
  $('body').css('overflow-y','auto'); //Prevent double scrollbar.
});


  
// sliders  
 
$('.our_iwt_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots:true,
    centerMode: true,
    centerPadding: '25%',
     responsive: [
     {
       breakpoint: 576,
       settings: {
         centerPadding: '10%',
       }
     }
   ]
  });  

$('.review_main_slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay:true,
    autoplaySpeed: 2000,
    dots:false,
   	responsive: [
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 480,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
  });

  $('.beforeafter-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    dots:false,
    autoplay:false,
    autoplaySpeed: 2000
  });
  $('.pro-richtext-reviews').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    autoplay:true,
    autoplaySpeed: 2000
  });   
 
 $('.brand-carousel').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});  
   

  $('a.smooth-redirect').on('click',function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top
    }, 300, 'swing', function () {
      // window.location.hash = target;
    });
  });

// $(function() {
//  var check_var_price =  $('.qty_swatch input:checked+label').find('.var_price').text();
//  var check_comvar_price =  $('.qty_swatch input:checked+label').find('.var_com_price').text();  
//   $('.desk_stcy_price, .stcy_pro_price').text(check_var_price);
//   $('.stcy_compro_price').text(check_comvar_price);
//   $('.qty_swatch .element').click(function() {
//     console.log('clickk')
//    var var_price = $(this).find('.var_price').text();
//    var comvar_price = $(this).find('.var_price').text(); 
//     $('.desk_stcy_price, .stcy_pro_price').text(var_price);
//     $('.stcy_compro_price').text(comvar_price);
//   });
// });

});

if ($(window).width() <= 767){
  $(window).scroll(function() {
    var scrolledY = $(window).scrollTop();
    $('.index_rich_text .gradient').css('background-position', 'center ' + ((scrolledY)) + '0px');
  });       
}

$(document).ready(function(){
  $('.faq_btn').on("click", function() {
    $(this).toggleClass("open").next().slideToggle(300);
  });
  
});

$(document).ready(function(){
  function logoSlider() {    
    $('.as-feat-section .main-logo-section').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      autoplay:true,
      autoplaySpeed: 2000,
      dots:false,
      responsive: [
       {
         breakpoint: 767,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1
         }
       }
     ]
    });
  }

$(window).resize(function(){
  if($(window).width() <= 991){
    logoSlider();
  }
});
if($(window).width() <= 991){
   logoSlider();
  }  

  
});

// Images Reveal on Text Scrolling

$( document ).ready(function() {
  
// Below code copied from theme.liquid

          if($('.global-media-settings video').length > 0)
      {
        setTimeout(function(){
          document.querySelector(".global-media-settings video").play();
        },1000);
      }

$(".video-container").each(function() {
  // Video
  var $video_container = $(this);
  var $video = $(this).find("video");

  // Video Controls
  var $video_controls = $(this).find(".video-inner-container");
   var $play_button = $(this).find(".play-gif");

  function playVideo(){
    if ($video[0].paused){
      $video[0].play();
      $video_controls.addClass("playing");
    } else {
      $video[0].pause();
      $video_controls.removeClass("playing"); 
    }
  }

  // Play/pause on button click
  $play_button.click(function() {
    playVideo();
  });

});

var vids = $(".video-container video"); 
$.each(vids, function(){
       this.controls = false; 
}); 

$(document).on("click",".pro-stamped-badge",function() {
  $('html,body').animate({scrollTop: $("#stamped-main-widget").offset().top},1000);
});
  
// $(".pro-vid-img-section .vid_img_btn .btn").on("click",function(event){
//     $('html,body').animate({scrollTop: $("product-form.product-form").offset().top - 500},2000);  
//   });  


  $('.slider-video').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    }     
  ]
});   
  });   

$( document ).ready(function() {

    $('.desk_sticky_cart').hide();
    $('.sticky_cart.mbl_cart').hide();
    if($('button.play-pause.bar.paused').length > 0) {
          $('button.play-pause.bar.paused').trigger('click');
    }

   $('.sticky_addtocart, .product-iwt-claim .claim-btn, .pro-vid-img-section .vid_img_btn .btn').click(function(){
    $('.product-form__submit').trigger('click');
  });
  
});

// $( document ).ready(function() {    
// var _learnq = _learnq || [];
// function addedToCart() {
//   fetch(`${window.location.origin}/cart.js`)
//   .then(res => res.clone().json().then(data => {
//     var cart = {
//       total_price: data.total_price/100,
//       $value: data.total_price/100,
//       total_discount: data.total_discount,
//       original_total_price: data.original_total_price/100,
//       items: data.items
//     }
//     if (item !== 'undefined') {
//       cart = Object.assign(cart, item)
//     }
//     _learnq.push(['track', 'Added to Cart', cart])
//   }))
// } 
// (function (ns, fetch) {
//   ns.fetch = function() {
//     var response = fetch.apply(this, arguments);
//     response.then(res => {
//       if (`${window.location.origin}/cart/add.js`
//       	.includes(res.url)) {
//         	addedToCart()
//       }
//     });
//     return response
//   }
// }(window, window.fetch))
// $(document).ajaxComplete(function(event, request, settings){
//   if(settings.url == "/cart/add.js"){
//       addedToCart()
//   }
// })
// });
// window.addEventListener('load', function() {
// var _learnq = window._learnq || [];
// function addedToCart() {
//   fetch(`${window.location.origin}/cart.js`)
//   .then(res => res.clone().json().then(data => {
//     var cart = {
//       total_price: data.total_price/100,
//       $value: data.total_price/100,
//       total_discount: data.total_discount,
//       original_total_price: data.original_total_price/100,
//       items: data.items
//     }
//     if (item !== 'undefined') {
//       cart = Object.assign(cart, item)
//     }
//     if (klAjax) {
//         _learnq.push(['track', 'Added to Cart', cart]);
//         klAjax = false;
//       }
//   }))
// };
// (function (ns, fetch) {
//   ns.fetch = function() {
//     var response = fetch.apply(this, arguments);
//     response.then(res => {
//       if (`${window.location.origin}/cart/add.js`
//        .includes(res.url)) {
//          addedToCart()
//       }
//     });
//     return response
//   }
// }(window, window.fetch));
// var klAjax = true;
// var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
// for (var i = 0; i < atcButtons.length; i++) {
//     atcButtons[i].addEventListener("click", function() {
//       if (klAjax) {
//         _learnq.push(['track', 'Added to Cart', item]);
//         klAjax = false;
//       }
//     })
// }
// });




 
      // $(window).scroll(function(){
      //        if($('#shopify-section-footer').length > 0 && $('#shopify-section-newsletter').length > 0)
      // {
      //   $('body').addClass('gradient-fixed');
      //   $('.sticky_cart.mbl_cart').hide();
      //   var footer_offset = $('#shopify-section-footer').offset().top -250;
      //   var sticky_height = $(window).height();
      //   var scroll = $(window).scrollTop();
      //   var sticky_new_top = $('#shopify-section-newsletter').offset().top ;
      //   sticky_new_top -= sticky_height;
      //   if(scroll >= sticky_new_top){  
      //     $('.desk_sticky_cart').addClass('hide');
      //   }
      //   else{
      //     $('.desk_sticky_cart').removeClass('hide');
      //   }
      //   if(scroll >= footer_offset){
      //     $('.desk_sticky_cart').hide();
      //   }
      //   else{
      //     $('.desk_sticky_cart').show();
      //   }
      // }
          
      //   if ($(window).width() <= 767) {
      //     $('.desk_sticky_cart').hide();
      //     // var sticky_top = $('#shopify-section-pro-rich-text').offset().top -200;
      //     var sticky_top;
      //     sticky_top -= sticky_height;
      //     if(scroll >= sticky_top){  
      //       $('.sticky_cart.mbl_cart').show();
      //       if(scroll >= footer_offset){
      //         $('.sticky_cart.mbl_cart').hide();
      //       }
      //       else{
      //         $('.sticky_cart.mbl_cart').show();
      //       }
      //     }
      //   }


      // });





// Accordion Default Closed - ai_gen_block_3d35da5
// 页面加载时确保所有包含 ai_gen_block_3d35da5 的手风琴菜单保持关闭状态
document.addEventListener('DOMContentLoaded', function() {
  // 通过 block ID 选择器定位 details 元素并移除 open 属性
  document.querySelectorAll('[id*="ai_gen_block_3d35da5"] details').forEach(function(details) {
    details.removeAttribute('open');
  });
  // 通过 shopify 编辑器 block 属性定位
  document.querySelectorAll('[data-shopify-editor-block*="ai_gen_block_3d35da5"] details').forEach(function(details) {
    details.removeAttribute('open');
  });
  // 通过 accordion 类名定位，检查其祖先元素是否包含 block ID
  document.querySelectorAll('.accordion details').forEach(function(details) {
    var blockEl = details.closest('[id*="ai_gen_block_3d35da5"]') || details.closest('[data-shopify-editor-block*="ai_gen_block_3d35da5"]');
    if (blockEl) {
      details.removeAttribute('open');
    }
  });
});
